import { useMutation } from '@tanstack/react-query';
import { UseMutationOptions } from '@tanstack/react-query/build/legacy/types';

import { apiForgotPassword } from '@app/Services/ForgotPassword/forgotPassword';

export function useForgotPassword(
	options: UseMutationOptions<unknown, unknown, { email: string }>
) {
	const mutation = useMutation({
		mutationFn: apiForgotPassword,
		...options,
	});

	const { mutate } = mutation;

	return {
		...mutation,
		doForgetPassword: mutate,
	};
}
